import React, { useState } from "react";
import Popup from "reactjs-popup";
import { Button, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import ServiceCalls from "../utils/serviceCalls";
import TimedDisplay from "../components/TimedDisplay";
import { Loading } from "../components/Loading";
import "../styles/PopUps.css";

const DeleteAttachmentPopUp = ({ attachment, loadTable, showButton }) => {
	const [open, setOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [deleteMsg, setDeleteMsg] = useState("");
	const [deleteMsgLevel, setDeleteMsgLevel] = useState("");
	const [isDeleteComplete, setDeleteComplete] = useState(false);

	const closeModal = () => {
		setOpen(false);
		setIsLoading(false);
		setDeleteMsg("");
		setDeleteMsgLevel("");
		setDeleteComplete(false);
	};

	const handleDelete = async () => {
		setIsLoading(true);
		try {
			let data = await ServiceCalls.deleteAttachment(attachment.storageUrl);
			if (data.isSuccessful) {
				setDeleteMsg("Attachment deleted successfully");
				setDeleteMsgLevel("success");
				setDeleteComplete(true);
			} else {
				setDeleteMsg("Failed to delete attachment");
				setDeleteMsgLevel("danger");
				setDeleteComplete(true);
			}
		} catch (error) {
			setDeleteMsg("An error occurred while deleting the attachment");
			setDeleteMsgLevel("danger");
			setDeleteComplete(true);
		}
		setIsLoading(false);
	};

	const showAlertMessage = () => {
		if (isDeleteComplete) {
			return (
				<TimedDisplay delay="3000" callback={loadTable}>
					<Alert variant={deleteMsgLevel}>{deleteMsg}</Alert>
				</TimedDisplay>
			);
		} else {
			return <></>;
		}
	};

	return (  
		<div>  
		  {showButton && (  
			<button className="uploadFileImg" onClick={() => setOpen((o) => !o)} title="Remove Attachment">  
			  <FontAwesomeIcon id="fa-remove" size="lg" icon={faTrashCan} />  
			</button>  
		  )}  
		
		  <Popup open={open} closeOnDocumentClick={false}>  
			<div className="del-attachment-popup-area">  
			  {isLoading ? (  
				<div style={{ paddingLeft: "230px" }}>  
				  <Loading loadingText={"Deleting..."}/>  
				</div>  
			  ) : (  
				<>  
				  {isDeleteComplete ? (  
					showAlertMessage()  
				  ) : (  
					<>  
					  <div className="del-attachment-header">  
						<h3>Are you sure you want to delete this attachment?</h3>  
					  </div>  
					  <div className="attachment-buttons">  
						<Button className="attachment-popup-buttons" onClick={closeModal}>  
						  No  
						</Button>  
						<Button className="attachment-popup-buttons" onClick={handleDelete}>  
						  Yes  
						</Button>  
					  </div>  
					</>  
				  )}  
				</>  
			  )}  
			</div>  
		  </Popup>  
		</div>  
	  );  
};
export default DeleteAttachmentPopUp;
